import React from "react";
import { HiOutlineReply } from "react-icons/hi";
import { FiExternalLink, FiPhone } from "react-icons/fi";
import { renderWhatsappText } from "../../../../utils/whatsappText";

export interface PreviewButton {
  type: "url" | "phone";
  title: string;
}

export interface RawPreviewButton {
  type?: string;
  payment?: boolean;
  title?: string | Record<string, string>;
}

export const resolveButtonTitle = (
  title: string | Record<string, string> | undefined,
  language: string
): string =>
  typeof title === "string" ? title : title?.[language] || title?.fr || "";

/** Raw buttons as the API ships them, rendered in the message's own language. */
export const resolvePreviewButtons = (
  buttons: RawPreviewButton[] | null | undefined,
  language: string
): PreviewButton[] =>
  (buttons ?? [])
    .filter((button) => button?.type === "url" || button?.type === "phone")
    .map((button) => ({
      type: button.type as "url" | "phone",
      title: resolveButtonTitle(button.title, language),
    }))
    .filter((button) => button.title.length > 0);

interface WhatsAppMessagePreviewProps {
  imageUrl?: string | null;
  body: string;
  isMarketing: boolean;
  buttons?: PreviewButton[];
}

const WhatsAppMessagePreview: React.FC<WhatsAppMessagePreviewProps> = ({
  imageUrl,
  body,
  isMarketing,
  buttons,
}) => {
  const ctaButtons = (buttons || []).filter((b) => b.title.trim().length > 0);
  return (
    <div className="rounded-lg bg-gray-100 p-4">
      <div className="mx-auto max-w-xs overflow-hidden rounded-lg bg-white shadow-sm">
        {imageUrl && (
          <img src={imageUrl} alt="" className="h-40 w-full object-cover" />
        )}
        <div className="px-3 py-2">
          <p className="whitespace-pre-wrap text-sm text-gray-800">
            {renderWhatsappText(body)}
          </p>
          <div className="mt-1 text-right text-xs text-gray-400">12:30</div>
        </div>
        {ctaButtons.map((button, index) => (
          <button
            key={`${button.type}-${index}`}
            type="button"
            disabled
            className="flex w-full items-center justify-center gap-1.5 border-t border-gray-100 py-2 text-sm font-medium text-blue-600"
          >
            {button.type === "phone" ? (
              <FiPhone className="h-4 w-4" />
            ) : (
              <FiExternalLink className="h-4 w-4" />
            )}
            {button.title}
          </button>
        ))}
        {isMarketing && (
          <button
            type="button"
            disabled
            className="flex w-full items-center justify-center gap-1.5 border-t border-gray-100 py-2 text-sm font-medium text-blue-600"
          >
            <HiOutlineReply className="h-4 w-4" />
            Stop promotions
          </button>
        )}
      </div>
    </div>
  );
};

export default WhatsAppMessagePreview;
